export enum InventoryRouteEnum {
  MAIN = "inventory.main",
}
